import api from './api';

/**
 * Tracks phone number views, call clicks, WhatsApp chats, and copy actions across the entire platform.
 * Non-blocking and silent on error.
 * 
 * @param {Object} params
 * @param {'officer' | 'business' | 'blood_donor' | 'other'} params.targetType
 * @param {string} [params.targetId]
 * @param {string} params.targetName
 * @param {string} [params.targetCategory]
 * @param {string} params.viewedPhone
 * @param {'call_click' | 'whatsapp_click' | 'copy_number' | 'view_number'} [params.action]
 * @param {string} [params.pageUrl]
 */
export const trackPhoneView = ({
  targetType,
  targetId,
  targetName,
  targetCategory,
  viewedPhone,
  action = 'call_click',
  pageUrl
}) => {
  if (!viewedPhone || !targetName || !targetType) return;

  const currentUrl = pageUrl || (typeof window !== 'undefined' ? window.location.pathname : '');

  api.post('/phone-logs', {
    targetType,
    targetId: targetId ? String(targetId) : '',
    targetName: String(targetName).trim(),
    targetCategory: targetCategory ? String(targetCategory).trim() : '',
    viewedPhone: String(viewedPhone).trim(),
    action,
    pageUrl: currentUrl
  }).catch((err) => {
    // Non-blocking silent catch
    console.debug('Phone tracking debug:', err?.message);
  });
};

export default trackPhoneView;
